import { render, staticRenderFns } from "./RevisionDoneList.vue?vue&type=template&id=012d2279&scoped=true"
import script from "./RevisionDoneList.vue?vue&type=script&lang=js"
export * from "./RevisionDoneList.vue?vue&type=script&lang=js"
import style0 from "./RevisionDoneList.vue?vue&type=style&index=0&id=012d2279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012d2279",
  null
  
)

export default component.exports